<template>
  <div class="login">
    <form @submit.prevent="loginForm" autocomplete="off">
      <h2>Welcome to our Virtual Event</h2>
      <div class="formActions">
        <button type="submit">Enter event</button>
      </div>
      <div class="failedLogin" :class="{ error: errorFailedLogin }">
        <p>The details you have entered is incorrect</p>
      </div>
    </form>
    <div class="formFooter">
      <h4>Optimal performance</h4>
      <p>
        This virtual event is a highly immersive 3D experience. For optimal
        performance, we advise visiting from a computer that meets the
        recommended specs.
      </p>
      <p class="popup" @click="performancePopup()">Learn more</p>
    </div>
    <PerformancePopupWindow
      v-if="$store.state.popup.data.currentPopup === 'Performance'"
    />
  </div>
</template>

<script>
import PerformancePopupWindow from "@/components/Popups/Performance";

var i;

export default {
  name: "Login",
  components: {
    PerformancePopupWindow,
  },
  data: () => ({
    errors: false,
    errorFailedLogin: false,
    fields: [
      {
        id: 1,
        name: "emailaddress",
        label: "Email Address",
        type: "email",
        placeholder: "Enter your email address...",
        value: "",
        error: false,
        errorValidField: false,
      },
    ],
    performancePopupWindow: false,
  }),
  methods: {
    loginForm() {
      this.error = false;
      this.errorFailedLogin = false;
      if (this.error === false) {
        const Body = {
          email: "ultimaker@enginecreative.co.uk",
        };
        this.$http({
          method: "post",
          url: this.$store.state.api.auth + "Login",
          data: Body,
        })
          .then((response) => {
            localStorage.setItem("token", response.data.loginToken);
            console.log(response);
            // localStorage.setItem('token', 'placeholder');
            location.reload();
          })
          .catch(() => {
            this.error = true;
            this.errorFailedLogin = true;
          });

        // if(this.fields[0].value === "ultimaker@enginecreative.co.uk"){
        //   localStorage.setItem('token', 'placeholder');
        //   location.reload();
        // } else {
        //   this.error = true
        //   this.errorFailedLogin = true
        // }
      }
    },
    performancePopup() {
      this.$store.commit("popup/popupCommit", {
        currentPopup: "Performance",
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Auth/Login";
</style>
